var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({attrs:{"data-cy":_vm.dataCy},scopedSlots:_vm._u([{key:"loader",fn:function(){return [_c('ProgressCircularTimeout')]},proxy:true}])},'v-btn',_vm.$props,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }